import AdminDashboard from './admin_dashboard';

export {
  AdminDashboard
};
